import React from 'react';
import { Icons } from 'widget/components';

interface Button {
  isPlaying: boolean;
  onClick: () => void;
}

const Button = ({ isPlaying, onClick }: Button) => (
  <button className="whatcrm-widget-audio__btn" onClick={onClick} type="button">
    {isPlaying ? (
      <Icons.Pause fill="white" size={20} />
    ) : (
      <Icons.Play fill="white" size={20} />
    )}
  </button>
);

export default Button;
